"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fill = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Module dependencies.
 */

/**
 * Export `Fill` component.
 */


var Fill = _styledComponents.default.div.withConfig({
  displayName: "fill__Fill",
  componentId: "anbcre-0"
})(["bottom:0;left:0;position:absolute;right:0;top:0;"]);

exports.Fill = Fill;